/**
 * Common utility behavior for enums.
 *
 * Usage (in an extending module):
 *
 * import Enum from "./Enum";
 * const myEnum = Object.create( Enum );
 * myEnum.FOO_KEY = "FOO_VALUE";
 * myEnum.BAR_KEY = "BAR_VALUE";
 * export default Object.freeze( myEnum );
 *
 * // Then, in a consuming module:
 * // import { MyEnum } from "@teaming/common-enums";
 * // MyEnum.keyFor( "FOO_VALUE" ) === "FOO_KEY";
 */
export default {
	keys() {
		return Object.keys( this );
	},

	values() {
		return this.keys().map( key => this[ key ] );
	},

	pairs() {
		return this.keys().map( key => [
			key,
			this[ key ],
		] );
	},

	keyFor( value ) {
		const keys = Object.keys( this );
		for ( const key of keys ) {
			if ( this[ key ] === value ) {
				return key;
			}
		}
		return undefined;
	},

	includes( value ) {
		return this.values().includes( value );
	},

	toString() {
		return JSON.stringify( this );
	},
};



// WEBPACK FOOTER //
// ./src/constants/Enum.js